<template>
  <svg :class="$style.container" width="20" height="20" viewBox="0 0 10 10">
    <circle
      :class="{ [$style.circle]: true, [$style.checked]: checked }"
      cx="5"
      cy="5"
      r="4"
      fill="none"
      stroke-width="1"
    />
    <circle
      :class="{ [$style.dot]: true, [$style.checked]: checked }"
      cx="5"
      cy="5"
    />
  </svg>
</template>

<script>
export default {
  name: 'radio-button',

  props: {
    checked: { Boolean }
  }
}
</script>

<style lang="scss" module>
.container {
  vertical-align: middle;
}

.circle {
  stroke: $color-icons;

  &.checked {
    stroke: $color-primary-light;
  }
}

.dot {
  fill: $color-primary-light;
  transition: r 0.2s;
  r: 0;

  &.checked {
    r: 2px;
  }
}
</style>
